<template>
    <div></div>
</template>

<script>
  export default {
    name: 'MessageControl',
    props: ['question', 'callback'],
    mounted: function(){
      this.$props.question.value = 1;
      this.update_done_status();
    },
    methods: {
      update_done_status: function () {
        this.$emit('answered', {
          'status': true,
          'id': this.$props.question.id,
          'value': 1,
        });
      }
    }
  }
</script>

<style scoped>

</style>
